//Initialize Accordion
if(document.querySelector('.accordion-container')){
  new Accordion(".accordion-container");
}

//Carousel Script

if (document.querySelector(".glide__slides")) {
  document.querySelector(".glide__slides").style.display = "flex";
  
  var allSlides = document.querySelectorAll(".glide");
  var allSlidesArray = Array.prototype.slice.call(allSlides);
  allSlidesArray.forEach((slide) => {
    const glide = new Glide(slide, {
      type: "slider",
      perView: 3,
      perTouch: 1,
      focusAt: "center",
      autoplay: false,
      accessibility: true,
      startAt: 2,
      rewind: false,
      classes: {
        disabledArrow: "glide__arrow--disabled",
      },
      peek: {
        before: 100,
        after: 50,
      },
      perSwipe: "|",
      breakpoints: {
        800: {
          perView: 1,
          startAt: 1,
          peek: 0,          
        },
      },
    }).mount();
  });
}

// $('.glide__arrow--right').on('click', function () {
//   $('.glide__arrow--right').removeClass('disabled');

//   var totalslides = $('.glide__bullet').length;

//   if ($('.glide__bullet')[totalslides - 1].hasClass('glide__bullet--active')) {
//     console.log('last');
//     $('.glide__arrow--right').addClass('disabled');
//   }
// })

//Check if Header Button link is external
const btns = document.querySelectorAll('.wp-block-button__link');
const allBtns = Array.prototype.slice.call(btns);
const currentHost = window.location.hostname;

let externalText = document.createElement("span");       
externalText.append(document.createTextNode("link will open external site"));
externalText.classList.add('screen-reader-text');

if(btns){
  allBtns.forEach(btn => {  
    if(btn.hasAttribute("href")){
      let ctaLink = btn.getAttribute("href").split("/");       
     
      if (ctaLink[2] !== currentHost) {
        btn.classList.add("external-link");
        btn.append(externalText);        
      }
    }    
  });
}
if (document.querySelector(".cta-btn")) {
  let currentHost = window.location.hostname;
  let ctaBtn = document.querySelector(".cta-btn");
  let ctaLink = ctaBtn.getAttribute("href").split("/");

  if (ctaLink[0] !== currentHost) {
    ctaBtn.classList.add("external-link");
    ctaBtn.append(externalText);
  }
}

//Menu
let hamicon = document.querySelector(".hamicon");
let nav = document.querySelector(".only-mobile-menu .main-navigation");
let hamMenu = document.querySelector(".main-navigation.hamburger-menu");
const mq = window.matchMedia("(max-width: 959px)");

//Ham Menu
if (hamMenu) {
  hamMenu.style.display = "none";
}

let primaryMenu = Array.prototype.slice.call(document.querySelectorAll('.primary-menu'));

mq.onchange = (e) => {
  if (mq.matches) {
    if(nav){
      nav.style.display = "none";
    }    
    
    if(hamicon){
      hamicon.style.display = "block";
    }

    if (document.querySelector(".mobile-menu-icon")) {
      document.querySelector(".mobile-menu-icon").style.display = "block";
    }    

  } else {
    if(nav){
      nav.style.display = "block";
    }    

    if(hamicon){
      hamicon.style.display = "none";
    }
    if(document.querySelector(".mobile-menu-icon")){
      document.querySelector(".mobile-menu-icon").style.display = "none";
    }  

    primaryMenu.forEach(menu => {
      menu.style.height = "auto";
    });
    //document.querySelector('#primary-menu').style.height = "auto";
  }
};
mq.onchange();

let openMobileNav = (e) => {
  hamicon.classList.toggle("is-active");
  if(nav){
    nav.classList.toggle("active");
  }
  
  document.getElementById("overlay").classList.toggle("active");
  document.getElementsByTagName("BODY")[0].classList.toggle("no-scroll");
  if(nav){
    nav.focus();
  }  

  let menuLabel = document.querySelector(".mobile-menu-label");
  let menuParentList = primaryMenu[1];

  if(document.querySelector('.menu-with-cta-right').children.length == 0 || document.querySelector('.menu-with-cta-right .ham-menu')){        
    menuParentList = primaryMenu[0];
  }
  

  //|| document.querySelector('.hamicon.ham-menu').length > 0

  //let menuParentList = document.querySelector('#primary-menu');
  let menuFromTop = menuParentList.getBoundingClientRect().top;

  menuParentList.classList.toggle('active-submenu');

  //if (menuLabel) {
    if (nav.classList.contains("active")) {
      menuLabel.innerText = "Close";      
      hamicon.setAttribute('aria-label', 'close the menu');
      hamicon.setAttribute('aria-expanded', 'true');
      menuParentList.style.height = 'calc(100vh - ' + menuFromTop + 'px)';    
    } else {
      menuLabel.innerText = "Menu";
      hamicon.setAttribute('aria-label', 'open the menu');
      hamicon.setAttribute('aria-expanded', 'false');
    }
  //}

};

if(hamicon){  
  if(document.querySelector('.menu-with-cta .ham-menu')){
    nav = document.querySelector(".main-navigation");
  }
  
  //nav = document.querySelector(".main-navigation");
  hamicon.style.display = 'block';
  hamicon.addEventListener("click", openMobileNav);
  hamicon.addEventListener("keydown", (e) => {
    if (e.keyCode == 13 || e.keyCode == 32) {
      openMobileNav();
    }
  });
}

//Submenu Arrow Icon
var arrowchevron = document.createElement("div");
arrowchevron.classList.add("arrow-down");
arrowchevron.setAttribute("tabindex", 0);
arrowchevron.setAttribute("role", 'button');
//arrowchevron.setAttribute('aria-label', 'Open submenu');
//arrowchevron.innerHTML = '<span class="screen-reader-text">Technology</span>'

let parentMenu = document.querySelectorAll(".menu-item-has-children > a");
let allparentMenu = Array.prototype.slice.call(parentMenu);

allparentMenu.forEach((menu) => {
	let parentName = menu.textContent;
	menu.setAttribute("aria-haspopup", true);
	menu.appendChild(arrowchevron.cloneNode(true));

	let arrow = menu.children[0],
		submenu = menu.nextSibling.nextSibling;

	arrow.setAttribute("aria-label", "Open " + parentName + " Submenu");

	if (screen.width < 960) {
		arrow.addEventListener("click", (e) => {
			// closeAllSubmenu();
			arrow.classList.toggle("rotate");
			submenu.classList.toggle("open-submenu");

			if (submenu.classList.contains("open-submenu")) {
				submenu.setAttribute("aria-expanded", true);
				arrow.setAttribute("aria-label", "Close " + parentName + " Submenu");
			} else {
				submenu.setAttribute("aria-expanded", false);
				arrow.setAttribute("aria-label", "Open " + parentName + " Submenu");
			}
			e.preventDefault();
		});
	}

	arrow.addEventListener("keydown", (e) => {
		if (e.keyCode == 13 || e.keyCode == 32) {
			arrow.classList.toggle("rotate");
			submenu.classList.toggle("open-submenu");
			e.preventDefault();

			if (submenu.classList.contains("open-submenu")) {
				closeAllSubmenu();
				arrow.classList.toggle("rotate");
				submenu.classList.toggle("open-submenu");
				submenu.setAttribute("aria-expanded", true);
				arrow.setAttribute("aria-label", "Close " + parentName + " Submenu");
			} else {
				submenu.setAttribute("aria-expanded", false);
				arrow.setAttribute("aria-label", "Open " + parentName + " Submenu");
			}
		}
	});
});

function closeAllSubmenu() {
	let allArrows = document.querySelectorAll(".arrow-down");
	allArrows.forEach((ele) => {
		ele.classList.remove("rotate");
		ele.setAttribute("aria-label", "Open " + ele.parentElement.textContent + " Submenu");
		let subM = ele.parentElement.nextElementSibling;
		subM.classList.remove("open-submenu");
		subM.setAttribute("aria-expanded", false);
	});
}

////Pagination
if (document.querySelector(".navigation-pagination")) {
  let paginationList = document.querySelectorAll(".navigation-pagination ul li");

  if (paginationList[0].classList.contains("active")) {
    paginationList[0].style.position = "relative";
  }

  if (paginationList[paginationList.length - 1].classList.contains("active")) {
    paginationList[paginationList.length - 1].style.position = "relative";
  }
}

////Masonary
if (document.querySelector(".allcontainer")) {
  var elem = document.querySelector(".allcontainer");
  var msnry = new Masonry(elem, {
    // options
    itemSelector: ".item",
    columnWidth: ".grid-sizer",
    gutter: 15,
  });

  //Filters
  // const filterBtn = document.querySelectorAll('.filters button');
  // var allfilterBtn = Array.prototype.slice.call(filterBtn);
  //let allblocks = document.querySelectorAll('.item');
  let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
  let selectedValue;
  let selectedOption;
  let availableItems;
  let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", onClickChange);
  }

  //Click Filter
  function onClickChange() {
    selectedValue = this.value;
    //console.log(selectedValue);
    // if(selectedValue !== 'all'){
    //   allblocks = document.querySelectorAll('.item.block');
    // }
    allblocks.forEach(function (block) {
      block.classList.remove("block");

      if (selectedValue == "all") {
        block.classList.add("block");
      }
      
      if (block.getAttribute("data-cat") == selectedValue) {
        block.classList.add("block");
      }
    });
    msnry.layout();

    availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
    document.getElementById("select").addEventListener("change", onSelectChange);
  }

  availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

  document.getElementById("select").addEventListener("change", onSelectChange);

  function onSelectChange() {
    selectedOption = this.value;

    availableItems.forEach(function (item) {
      item.classList.remove("block");

      if (selectedOption == "all") {
        item.classList.add("block");
      }

      if (item.getAttribute("data-tag") == selectedOption) {
        item.classList.add("block");
      }
    });

    //Filter Click
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", onClickChange);
    }

    msnry.layout();
  }

  /////Script_AJAX
  /* Ajax functions */
  $(document).ready(function () {
    //onclick
    $("#loadMore").on("click", function (e) {
      e.preventDefault();
      //init
      var that = $(this);
      var page = $(this).data("page");
      var newPage = page + 1;
      var ajaxurl = that.data("url");
      //ajax call
      $.ajax({
        url: ajaxurl,
        type: "post",
        data: {
          page: page,
          action: "ajax_script_load_more",
        },
        error: function (response) {
          console.log(response);
        },
        success: function (response) {
          //check
          if (response == 0) {
            $(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
            $("#loadMore").hide();
          } else {
            that.data("page", newPage);
            $("#ajax-primary").append(response);

            msnry = new Masonry(elem, {
              // options
              itemSelector: ".item",
              columnWidth: ".grid-sizer",
              gutter: 15,
            });

            msnry.layout();
          }
        },
      });
    });
  });
}

//Breadcrumb Spacing
if(document.querySelector('.breadcrumb-container')){
  document.querySelector('.content-area').style.marginTop = 0;
}

//Button Custom Colors Hover
// var customBtn = $(".wp-block-button a.has-text-color.has-background");

// customBtn.each(function (index) {
//   var btnbgColor = $(this).css("backgroundColor");
//   var btnColor = $(this).css("color");
//   //console.log(btnbgColor);

//   $(this)
//     .mouseenter(function () {
//       $(this).css({ "background-color": btnColor, color: btnbgColor, "border-color": btnColor });
//     })
//     .mouseleave(function () {
//       $(this).css({ "background-color": btnbgColor, color: btnColor, "border-color": btnbgColor });
//     });
// });

jQuery(document).ready(function(){
  jQuery(window).on('resize', function(){
      var win = $(this); //this = window
      
      if (win.width() <= 960) { 
          
          var isclosed = jQuery(".hamicon").attr("aria-expanded");
          if(isclosed == "true"){
              jQuery(".hamicon").trigger("click");
              isclosed = false;
          }
       }
  });
  });

  $(document).on('focusout', '#menu-main-menu-1', function (e) {
    setTimeout(function(){
        var focus=$(document.activeElement);
        if (focus.is("#menu-main-menu-1") || $('#menu-main-menu-1').has(focus).length) {
        } else {
          openMobileNav();
        }
    },0);
});

$(document).on('focusout', '.sub-menu', function (e) {
  setTimeout(function(){
      var focus=$(document.activeElement);
      if (focus.is(".sub-menu") || $('.sub-menu').has(focus).length) {
      } else {
        closeAllSubmenu();
      }
  },0);
});


  